/*
 * @Author: your name
 * @Date: 2021-08-09 09:47:33
 * @LastEditTime: 2021-10-26 17:32:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zq/src/page/index.tsx
 */
import React from 'react';
import { Foot } from './footer/index';
import './index.css';
// import { NavLink } from "react-router-dom";
import { poems } from './study/lunger.json';
import { barList } from "./api";

export class HomePage extends React.Component<{}, {}>{
    render() {
        console.log(window.navigator.userAgent);
        return <div>
            <div className='center'>
                <h1>诚挚的欢迎您</h1>
                <div className='said'>
                    赠君言：<span className='saidTitle'>{poems[Math.floor(Math.random() * poems.length)]}</span>
                </div>
                {this.bar()}
                {/* <div style={{ backgroundImage: 'https://www.imgacademy.cn/themes/custom/imgacademy/images/helpbox-contact.jpg' }}>

                </div>
                <a href="/Mathematics">4年纪以下福利区</a>
                <p>
                    <a href="https://www.yuque.com/dashboard" target='_blank' > 知识库</a>
                </p> */}
            </div>
            <Foot />
        </div>
    }
    bar() {
        let row: JSX.Element[] = [];
        barList.map((item, index) => {
            row.push(
                <a className={`${index + 1 !== barList.length ? 'composing' : 'composing1'}`} key={index} href={`${item.link}`}>
                    <img src={`${item.url}`} alt={`${item.title}`} />
                    <p>{`${item.title}`}</p>
                </a>
            )
        })
        return <div>{row}</div>
    }
}